import React from 'react';
import { Loader, Text } from '@vibe/core';
import { useApprovalStore } from '../../stores/approvalStore';
import TimesheetListRow from './TimesheetListRow';

export interface TimesheetPendingListProps {
  /** Map of user IDs to display names. */
  userNameMap?: Record<string, string>;
}

const TimesheetPendingList: React.FC<TimesheetPendingListProps> = ({
  userNameMap,
}) => {
  const pendingTimesheets = useApprovalStore((s) => s.pendingTimesheets);
  const pendingLoading = useApprovalStore((s) => s.pendingLoading);
  const selectedTimesheetId = useApprovalStore((s) => s.selectedTimesheetId);
  const setSelectedTimesheetId = useApprovalStore(
    (s) => s.setSelectedTimesheetId,
  );

  if (pendingLoading) {
    return (
      <div className="rp-ts-pending-list__loading">
        <Loader size={Loader.sizes.MEDIUM} />
      </div>
    );
  }

  if (pendingTimesheets.length === 0) {
    return (
      <div className="rp-ts-pending-list__empty">
        <Text type={Text.types.TEXT2} color={Text.colors.SECONDARY}>
          No pending timesheets to review.
        </Text>
      </div>
    );
  }

  return (
    <div className="rp-ts-pending-list">
      {pendingTimesheets.map((ts) => (
        <TimesheetListRow
          key={ts.id}
          submission={ts}
          userName={userNameMap?.[ts.userId]}
          isSelected={selectedTimesheetId === ts.id}
          onClick={() => setSelectedTimesheetId(ts.id)}
        />
      ))}
    </div>
  );
};

export default TimesheetPendingList;
